var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center lang-option",on:{"click":_vm.changeLang,"touchstart":_vm.changeLang}},[_c('icon',{attrs:{"icon":_vm.icons[_vm.code]}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.labels[_vm.code]))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }